import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/corporate", label: "Corporate", id: "nav-corporate-link" },
  { to: "/creative", label: "Creative", id: "nav-creative-link" },
  { to: "/about", label: "About", id: "nav-about-link" },
  { to: "/contact", label: "Contact", id: "nav-contact-link" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <>
      <header className="fixed inset-x-0 top-0 z-50 text-white mix-blend-difference" data-testid="main-nav">
        <div className="flex h-16 items-center justify-between px-6 lg:px-12">
          <Link
            to="/"
            data-testid="nav-logo"
            className="font-mono text-xs uppercase tracking-[0.35em]"
            aria-label="Haus Ov Harii, home"
          >
            Haus Ov Harii
          </Link>
          <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={l.id}
                className={({ isActive }) =>
                  `font-mono text-[11px] uppercase tracking-[0.25em] transition-opacity duration-300 hover:opacity-60 ${
                    isActive ? "underline underline-offset-8" : ""
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <button
            data-testid="nav-menu-toggle"
            className="md:hidden"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            aria-label="Mobile"
            className="fixed inset-0 z-40 flex flex-col justify-center bg-[#0B0C0E] px-8 md:hidden"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
          >
            {links.map((l, i) => (
              <motion.div
                key={l.to}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.08 + i * 0.07, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              >
                <NavLink
                  to={l.to}
                  data-testid={`mobile-${l.id}`}
                  className="block border-b border-white/10 py-5 text-4xl font-light tracking-tight"
                >
                  {l.label}
                </NavLink>
              </motion.div>
            ))}
            <motion.p
              className="mt-10 font-mono text-[11px] uppercase tracking-[0.3em] text-[#616775]"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.45 }}
            >
              Haus Ov Harii · Est. 05/2016
            </motion.p>
          </motion.nav>
        )}
      </AnimatePresence>
    </>
  );
}
